import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserForm from "components/Forms/UserForm/UserForm";
import { User, GroupMember, UserBusinessUnits } from "types";
import { createUser } from "app/features/userSlice";
import { getGroups } from "app/features/groupsSlice";
import { getBusinesses } from "app/features/businessesSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import FormCard from "components/Forms/FormCard/FormCard";
import withAuth from "lib/hoc/withAuth";

const UserCreate = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.user) ?? [];

  const { groups } = useAppSelector((state) => state.groups) ?? [];
  const { businesses } = useAppSelector((state) => state.businesses) ?? [];

  const [groupSelected, setGroupSelected] = useState<GroupMember[]>([]);
  const [businessesSelected, setBusinessesSelected] = useState<UserBusinessUnits[]>([]);

  /* HERE WE CALL THE API /Security/SaveUser */
  const onCreateUser = async (user: User) => {
    await dispatch(createUser(user));
    navigate("/admin/users", { replace: false });
  };

  useEffect(() => {
    dispatch(getGroups());
    dispatch(getBusinesses());
  }, []);

  return (
    <FormCard maxWidthCard={775} maxWidthContainer='md' title='Nuevo Usuario'>
      <UserForm
        groups={groups}
        loading={loading}
        businesses={businesses}
        handleSubmit={onCreateUser}
        groupSelected={groupSelected}
        submitButtonText='Crear Usuario'
        setGroupSelected={setGroupSelected}
        businessesSelected={businessesSelected}
        setBusinessesSelected={setBusinessesSelected}
      />
    </FormCard>
  );
};

export default withAuth(UserCreate);
